import { FaPlus } from 'react-icons/fa';
import { IconButton } from 'components/UI';

type ParameterButtonProps = {
  modelKey: string | number;
  onClick: (key: string | number) => void;
  title: string;
};

const ParameterButton = ({ modelKey, onClick, title }: ParameterButtonProps) => (
  <IconButton aria-label={title} onClick={() => onClick(modelKey)} icon={<FaPlus />} title={title} />
);

export default ParameterButton;
